import $ from 'jquery';

$(() => {
  if ($('.js-clear-search').length > 0) {
    $('.js-clear-search').on('click', () => {
      $('.js-main-search-input').val('');
      $(this).addClass('hide');
    });
  }
});



/** WEBPACK FOOTER **
 ** ./src/js/main-search.js
 **/